import Footer from "../components/Footer.jsx";
import { useLocalStorage } from "../hooks/useLocalStorage.jsx";
import { callAPI } from "../hooks/CallAPI.jsx";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const CreateAllAccounts = () => {
  const [count, setCount] = useState(0);
  const [created_users, setCreatedUsers] = useState(0);
  const [error, setError] = useState([]); 
  const [isLoading, setIsLoading] = useState(true);
  const [user] = useLocalStorage("user", null);

  useEffect(() => {
    const fetchAccounts = async () => {
      if (!user || !user.access_token) {
        console.warn("Aucun utilisateur connecté !");
        return;
      }

      try {
        console.log("appel api");
        const response = await callAPI('/create-account-espace-client', {
          access_token: user.access_token
        });

        console.log("réponse api", response);

        if (response?.success) {
          // Utiliser une valeur par défaut pour éviter undefined
          setCount(response.datas?.count ?? 0);
          setCreatedUsers(response.datas?.created_users ?? 0);
          setError(response.datas?.errors ?? []);
        } else {
          console.error("API call failed:", response);
          toast.error("Erreur lors de la récupération des comptes.");
        }

      } catch (error) {
        console.error("API error:", error);
        toast.error("Impossible de contacter l'API.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAccounts();
  }, [user]);

  return (
    <div className="flex flex-col justify-between h-screen">
      <div className="header bg-mgray text-mdark py-8 px-10 text-center">
        <h1 className="text-xl sm:text-4xl font-extrabold text-mlime mb-4 uppercase">
          Super admin
        </h1>
        <p className="text-lg font-bold text-custom-color">
          Créations de tous les comptes de l'espace client
        </p>
      </div>

      <div className="container m-auto pt-10 text-center">
        {isLoading ? (
          <p>Chargement des comptes...</p>
        ) : (
          <>
            <p className="text-xl font-bold">
              Nombre total de contrats récupérés : {count}
            </p>
            <p className="text-xl font-bold">
              Nombre total de comptes créés : {created_users}
            </p>

            {error.length > 0 ? (
              <div className="mt-4 text-red-500">
                <p className="text-xl font-bold mt-4">Erreur(s) détectée(s) :</p>
                <ul className="text-lg mt-2">
                  {error.map((err, index) => (
                    <li key={index}>
                      Contrat ID {err.contrat_id} - {err.raison_sociale} : {err.message}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <p className="text-xl font-bold text-green-600">Aucune erreur détectée.</p>
            )}
          </>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default CreateAllAccounts;
